import React from 'react';
import CrmInteractionsListPage from './components/CrmInteractionsListPage';

export default function EmailsPage() {
  return (
    <CrmInteractionsListPage
      pageKey="emailsPage"
      typeFilter="email"
      showFollowUp
      showDealAmount
    />
  );
}
